import PersonHeader from './PersonHeader';

export default PersonHeader;
